import { Box } from '@mui/material'

const Valores = () => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                width: '100vw',
                lineHeight: '2rem',
                flexWrap: 'wrap',
                gap: '0.5rem',
            }}
        >
            <Box sx={{
                textAlign: "center",
                width: '100vw',
                color: 'white',
                fontFamily: 'roboto',
                display: 'flex',
                flexWrap: 'nowrap',
                flexGrow: '1',
                textAlignLast: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '0.5rem',
                '& > div': {
                    backgroundColor: 'primary.main',
                    padding: '0.2rem 0.5rem',
                    width: '5em',
                }
            }}>
                <Box>Riesgo</Box>
                <Box>bajo</Box>
                <Box>medio</Box>
                <Box>alto</Box>
                <Box>muy alto</Box>
            </Box>
            <Box sx={{
                fontFamily: "Roboto",
                textAlignLast: 'center',
                justifyContent: 'center',
                alignItems: 'center',
                display: 'flex',
                flexWrap: 'nowrap',
                width: '100vw',
                flexGrow: 1,
                gap: '0.5rem',
                '& > div': {

                    padding: '0.2rem 0.5rem',
                    width: '5em',
                }
            }}>
                <Box sx={{ backgroundColor: 'primary.main', color: 'white' }}>FWI</Box>
                <Box>[0,10)</Box>
                <Box>[10,15)</Box>
                <Box>[15,20)</Box>
                <Box>20</Box>

            </Box>
        </Box >
    )
}

export default Valores
